import CartLineAddons from './cart-line-addons-view'

export default CartLineAddons
